import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { PullstateProvider } from 'pullstate';
import { useEffect } from 'react';

import { PageLayout } from '@/renderer/PageLayout';
import { PullstateCore } from '@/renderer/store';
import { IdleContextProvider } from '@/renderer/utils/useIdle';

// children includes <Page/>
export function Wrapper({ children }: { children: React.ReactNode }) {
  const pullstate = PullstateCore.instantiate({ ssr: true });

  const queryClient = new QueryClient();

  // `body.page-is-interactive` gates the JS-mode styles for components like
  // UserDropdown (the no-JS path leaves the menu trigger as pointer-events:none
  // so it can rely on :focus/:hover instead). +onHydrationEnd handles this for
  // SSR-then-hydration, but in SPA mode (Capacitor build) there's no hydration,
  // so the class never gets set and the menu becomes un-clickable.
  useEffect(() => {
    document.body.classList.add('page-is-interactive');
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <PullstateProvider instance={pullstate}>
        <IdleContextProvider>
          <PageLayout>{children}</PageLayout>
        </IdleContextProvider>
      </PullstateProvider>
    </QueryClientProvider>
  );
}
